<template>
  <el-dialog
    title="提案数据编辑窗口"
    :visible.sync="visible"
    width="1200px"
    @close="close">

    <el-form :inline="true" :model="PropEditForm" label-position="right">
      <el-form-item label="观测号">
        <el-input v-model="PropEditForm.obs_id" autocomplete="off" style="width:180px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="计划号">
        <el-input v-model="PropEditForm.schedule_id" autocomplete="off" style="width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间TT">
        <el-input v-model="PropEditForm.tstart" autocomplete="off" style="width:160px;"></el-input>
      </el-form-item>
      <el-form-item label="数据结束时间TT">
        <el-input v-model="PropEditForm.tsop" autocomplete="off" style="width:160px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间UTC">
        <el-date-picker v-model="PropEditForm.start_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据结束时间UTC">
        <el-date-picker v-model="PropEditForm.stop_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据时长">
        <el-input v-model="PropEditForm.duration" autocomplete="off" style="width:120px;"></el-input>
      </el-form-item>
      <el-form-item label="观测前Slew时长">
        <el-input v-model="PropEditForm.pre_slew" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="观测后Slew时长">
        <el-input v-model="PropEditForm.post_slew" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="观测目标">
        <el-input v-model="PropEditForm.target" autocomplete="off" style="width:290px;"></el-input>
      </el-form-item>
      <el-form-item label="观测模式">
        <el-select style="width:110px;" v-model="PropEditForm.obs_mode"  filterable placeholder="观测模式">
              <el-option
                  v-for="item in obsmode_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据模式">
        <el-select style="width:110px;" v-model="PropEditForm.data_mode"  filterable placeholder="数据模式">
              <el-option
                  v-for="item in datamode_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="观测提案">
        <el-input v-model="PropEditForm.proposal" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="观测者">
        <el-input v-model="PropEditForm.observer" autocomplete="off" style="width:290px;"></el-input>
      </el-form-item>
      <el-form-item label="提案类型">
        <el-select style="width:110px;" v-model="PropEditForm.ptype"  filterable placeholder="提案类型">
              <el-option
                  v-for="item in proposaltype_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据状态">
        <el-select style="width:130px;" v-model="PropEditForm.status"  filterable placeholder="数据状态">
              <el-option
                  v-for="item in status_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="ra">
        <el-input v-model="PropEditForm.ra" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="dec">
        <el-input v-model="PropEditForm.dec" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描速度">
        <el-input v-model="PropEditForm.speed" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描间隔">
        <el-input v-model="PropEditForm.interval" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描半径">
        <el-input v-model="PropEditForm.radius" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="偏轴标记">
        <el-input v-model="PropEditForm.offset" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="权属">
        <el-input v-model="PropEditForm.owner" autocomplete="off" style="width:220px;"></el-input>
      </el-form-item>
      <el-form-item label="公开">
        <el-select style="width:110px;" v-model="PropEditForm.isopen"  filterable placeholder="是否公开">
              <el-option
                  v-for="item in open_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据归档日期">
        <el-date-picker v-model="PropEditForm.archive_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据发布日期">
        <el-date-picker v-model="PropEditForm.release_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据公开日期">
        <el-date-picker v-model="PropEditForm.open_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="l1_file_id">
        <el-input v-model="PropEditForm.l1_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="l15_file_id">
        <el-input v-model="PropEditForm.l15_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="l2_file_id">
        <el-input v-model="PropEditForm.l2_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="生成时间">
        <el-date-picker v-model="PropEditForm.create_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="生成者">
        <el-input v-model="PropEditForm.create_by" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker v-model="PropEditForm.update_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新者">
        <el-input v-model="PropEditForm.update_by" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>    
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {datastatus_IE,DataMode,proposaltype_IE,ObsMode,Iopen_IE} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      PropEditForm:{
        id:'', 
        obs_id:'', 
        schedule_id:'', 
        tstart:'',
        tsop:'',
        start_utc:'',
        stop_utc:'',
        duration:'',
        pre_slew:'',
        post_slew:'',
        target:'',
        obs_mode:'',
        data_mode:'',
        proposal:'',
        observer:'',
        ptype:'',
        status:'',
        ra:'', 
        dec:'',
        speed:'',
        interval:'',
        radius:'',
        offset:'',
        owner:'',
        isopen:'', 
        archive_time:'',
        release_time:'',
        open_time:'',
        l1_file_id:'',
        l15_file_id:'',
        l2_file_id:'',
        create_time:'',
        create_by:'',
        update_time:'',
        update_by:'', 
      },
      obsmode_list:ObsMode,
      status_list:datastatus_IE,
      datamode_list:DataMode,
      proposaltype_list:proposaltype_IE,
      open_list:Iopen_IE,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.PropEditForm.id = data.id;
      this.PropEditForm.obs_id = data.obs_id;
      this.PropEditForm.schedule_id = data.schedule_id;
      this.PropEditForm.tstart = data.tstart;
      this.PropEditForm.tsop = data.tsop;
      this.PropEditForm.start_utc = data.start_utc;
      this.PropEditForm.stop_utc = data.stop_utc;
      this.PropEditForm.duration = data.duration;
      this.PropEditForm.pre_slew = data.pre_slew;
      this.PropEditForm.post_slew = data.post_slew;
      this.PropEditForm.target = data.target;
      this.PropEditForm.obs_mode = data.obs_mode;
      this.PropEditForm.data_mode = data.data_mode;
      this.PropEditForm.proposal = data.proposal;
      this.PropEditForm.observer = data.observer;
      this.PropEditForm.ptype = data.ptype;
      this.PropEditForm.status = data.status;
      this.PropEditForm.ra = data.ra;
      this.PropEditForm.dec = data.dec;
      this.PropEditForm.speed = data.speed;
      this.PropEditForm.interval = data.interval;
      this.PropEditForm.radius = data.radius;
      this.PropEditForm.offset = data.offset;
      this.PropEditForm.owner = data.owner;
      this.PropEditForm.isopen = data.isopen;
      this.PropEditForm.archive_time = data.archive_time;
      this.PropEditForm.release_time = data.release_time;
      this.PropEditForm.open_time = data.open_time;
      this.PropEditForm.l1_file_id = data.l1_file_id;
      this.PropEditForm.l15_file_id = data.l15_file_id;
      this.PropEditForm.l2_file_id = data.l2_file_id;
      this.PropEditForm.create_time = data.create_time;
      this.PropEditForm.create_by = data.create_by;
      this.PropEditForm.update_time = data.update_time;
      this.PropEditForm.update_by = data.update_by;      
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.PropEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
